var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"second-page-wrapper"},[_c('div',{staticClass:"second-page-wrapper-left"},[_c('common-slide',{attrs:{"slideList":_vm.titleList}})],1),_vm._v(" "),_c('div',{staticClass:"second-page-wrapper-right"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c8028f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/BuildingList/index.vue
// module id = null
// module chunks = 